import * as React from "react";
import { NAVBAR_HEIGHT } from "../../config";
import { THEME } from "../../theme/ThemeStore";
import { t } from "../../i18n/util";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { HrBotOrangeButton, ImageLogo } from "./Primitives";
import { authStore } from "../../stores/AuthStore";
import { pushRoute } from "../app/router/history";
import { HrRoutes } from "../hr/router/HrRoutes";

export const TopBar = () => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            className="body2"
            style={{
                display: "flex",
                height: isMobile ? 72 : NAVBAR_HEIGHT,
                alignItems: "center",
                justifyContent: "space-between",
                padding: isMobile ? 12 : 22
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: isMobile ? "flex-start" : "center",
                    gap: isMobile ? 2 : 48,
                    justifyContent: isMobile ? "space-between" : "flex-start",
                    flexDirection: isMobile ? "column" : "row"
                }}
            >
                <ImageLogo style={{ maxHeight: 32 }} />
                {t("screen.topbar.title")}
            </div>
            {!isMobile && authStore.credentials && (
                <HrBotOrangeButton
                    label={t("screen.topbar.backToHr")}
                    onClick={() => {
                        if (authStore.credentials) {
                            pushRoute(HrRoutes.DASHBOARD);
                        }
                    }}
                />
            )}
        </div>
    );
};
